import { render, staticRenderFns } from "./ScrollWidget.vue?vue&type=template&id=29aab66c&scoped=true&"
import script from "./ScrollWidget.vue?vue&type=script&lang=js&"
export * from "./ScrollWidget.vue?vue&type=script&lang=js&"
import style0 from "./ScrollWidget.vue?vue&type=style&index=0&id=29aab66c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29aab66c",
  null
  
)

export default component.exports